import React, {useState} from 'react';
import "react-datepicker/dist/react-datepicker.css";
import DatePicker, {registerLocale} from 'react-datepicker';
import WebformElementWrapper from './WebformElementWrapper';
import WebformDatepickerInput from './WebformDatepickerInput';
import { ca } from "date-fns/locale";
registerLocale("ca", ca);
//registerLocale("en", en);

const WebformDatetime = ({ children, ...props }) => {

  const [startDate, setStartDate] = useState(new Date());
  const isRequired = props?.element?.attributes[1]?.name == "#required" &&  props?.element?.attributes[1]?.value == "1" ? 1 : 0;
  const [language, setLanguage] = React.useState("ca");
  const {error} = props
    return(
      <div className={`form-group col-md-6 ${isRequired ? 'form-required' : ''}`}>
      <DatePicker
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        name={props?.element?.name}
        customInput={<WebformDatepickerInput error={error} isRequired={isRequired} element={props?.element} />}
        isRequired={isRequired}
        locale={language}
        dateFormat="dd-MM-yyyy"
        />
      </div>
    )
}
export default WebformDatetime;
//# sourceMappingURL=WebformDatetime.jsx.map
